import {Tooltip} from '@dropbox/dig-components/tooltips';
import {Box} from '@dropbox/dig-foundations';
import type {WorkstreamUpdate} from 'client';
import {StatusButtonIcon} from 'components/DSYS/StatusButtonIcon';
import {useWorkstreamDisplayStatus} from 'views/workstreams/hooks';
import {
  getWorkstreamUpdateVisualStatus,
  sortDependenciesByArchivedLastAndOrder,
} from 'views/workstreams/utils';

type WorkstreamWithStatus = {
  id: number;
  name: string;
  archived?: boolean;
  updates?: WorkstreamUpdate[];
};

export type DependencyWithStatus = {
  order: number;
  dependent: WorkstreamWithStatus;
};

const DependencyStatusScore = ({dependent}: {dependent: WorkstreamWithStatus}) => {
  const {latestUpdate} = useWorkstreamDisplayStatus(dependent);
  const status = latestUpdate?.status || 'no_status';

  return (
    <Tooltip
      placement="bottom"
      title={
        <Box
          style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '232px',
          }}
        >
          {dependent.name}
        </Box>
      }
    >
      <Box>
        <StatusButtonIcon status={getWorkstreamUpdateVisualStatus(status)} size="small" />
      </Box>
    </Tooltip>
  );
};

export const DependencyStatusScores = ({dependencies}: {dependencies: DependencyWithStatus[]}) => {
  const sortedDependencies = [...dependencies]
    .sort(sortDependenciesByArchivedLastAndOrder)
    .map((dep) => dep.dependent);

  if (sortedDependencies.length === 0) {
    return null;
  }

  return (
    <Box display="flex" style={{gap: 4}} flexWrap="wrap">
      {sortedDependencies.map((dependent) => (
        <DependencyStatusScore key={dependent.id} dependent={dependent} />
      ))}
    </Box>
  );
};
